var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockOpen = function SvgLockOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.688 4a1.874 1.874 0 1 1 3.75 0v1.688a.561.561 0 1 0 1.125 0V4a3 3 0 1 0-6 0v1.5H1.938c-.828 0-1.5.673-1.5 1.5v4.5c0 .828.672 1.5 1.5 1.5h7.5c.827 0 1.5-.672 1.5-1.5V7c0-.827-.673-1.5-1.5-1.5h-.75zm-6.75 2.625h7.5c.206 0 .374.17.374.375v4.5a.376.376 0 0 1-.374.375h-7.5a.376.376 0 0 1-.375-.375V7c0-.206.168-.375.375-.375"
  })));
};
export default SvgLockOpen;